module.exports = __webpack_public_path__ + "/images/nosotros-portada-responsive.eafd9e0.jpg";